import { LINE_HEIGHT, REM } from './typography';

export const SPACING_X = 26 / REM;
export const SPACING_Y = 24 / REM;
export const SPACING = LINE_HEIGHT;
